import React from 'react'
import styled from 'styled-components'

// import VideoImg from "../../assets/images/video.png"

export default function VideoSide() {
  return (
    <StyledVideo>
      <div className='redline'><span></span>Videos</div>
      <div className='video-img'>
        <iframe  height="430"
          src="https://www.youtube.com/embed/7irfYrrrG8w"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </StyledVideo>
  )
}

const StyledVideo = styled.div`
    .video-img{
      margin: 50px auto;
      width: 65%;

      iframe{
        width: 100%;
      }
      @media (max-width: 576px) {
          width: 100%;
          iframe{
            height: 300px;
          }
      }
    }
`
